
import { REACT_APP_PUBLIC_DIRECTUS_API } from "@/constants";
import directus from "@/lib/directus";
import { createItem } from "@directus/sdk";
import axios from "axios";


export const transactionService = {

    withdrawMoney: async (comercial_id: string, amount: number, phoneNumber: string, displayName: string): Promise<{
        success: boolean;
        error?: Error;
        redirectTo?: string;
    }> => {
        const directusAuth = localStorage.getItem('directus_auth');

        const accesToken = directusAuth ? JSON.parse(directusAuth).access_token : null;

        try {
            const response = await axios.post(`${REACT_APP_PUBLIC_DIRECTUS_API}/pay/commercial-cashout`, {
                amount: amount,
                api_key: accesToken,
                phone_number: phoneNumber,
                name: displayName,
                comercial_id: comercial_id,
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if ((response.status === 200 || response.status === 204)) {

                await directus.request(createItem("Retrait_Commercial", {
                    phone_number: phoneNumber,
                    Commercial_id: comercial_id,
                    montant: amount,
                    nom: displayName
                }));

                return {
                    success: true,
                    redirectTo: "/dashboard",
                }

            } else {
                return {
                    success: false,
                }
            }



        } catch (error: any) {
            console.debug(error)
            return {
                error: new Error(error.message || "Erreur lors de l'inscription"),
                success: false,
            };
        }
    },

};
